import { createAsyncThunk } from '@reduxjs/toolkit';
import type { ArticleData } from '@wix/wix-help-widget-common/homepage';

import { getRecommendedArticles } from '../../homepage/api';
import { HttpClientFactory } from '../httpClient';

export const loadRecommendedArticles = createAsyncThunk<
  { articles: ArticleData[]; modelId: string },
  { size: number; httpClient: HttpClientFactory }
>('loadRecommendedArticles', async ({ size, httpClient }) => getRecommendedArticles(size, httpClient));
